module.exports = __webpack_public_path__ + "img/lg_ring_g_0_null_null@2x.5d1b1fa5.png";